module.exports = __webpack_public_path__ + "static/media/aluminium.3ea8b16d.png";